import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { DismissPromptAction, LoadDismissablePromptsAction } from '../../domains/dismissablePrompts/actions.types';

import { DismissablePrompts } from './types';

export type DismissablePromptsAction = DismissPromptAction | LoadDismissablePromptsAction;

const initialState: DismissablePrompts = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<DismissablePrompts, DismissablePromptsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'DISMISSABLE_PROMPTS.LOAD_PENDING':
      return moveToPending(state, action.payload.promptKeys);
    case 'DISMISSABLE_PROMPTS.LOAD_REJECTED':
      return moveToRejected(state, action.payload.promptKeys, action.payload.error);
    case 'DISMISSABLE_PROMPTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.dismissablePrompts);
    case 'DISMISSABLE_PROMPTS.DISMISS_PROMPT_FULFILLED':
      return update(state, action.payload.promptKey, { isDismissed: true });
    default:
      return state;
  }
};

export default reducer;
